import React, { useState } from 'react';

export const InputTextModern = ({
	id,
	name,
	type = 'text',
	label,
	onChange,
	value,
	placeholder,
	disabled = false,
	icon: Icon = null,
	error = null,
	required = false,
	/** Si es un número &gt; 0, se renderiza &lt;textarea&gt; con el mismo estilo que el input. */
	rows = null,
}) => {
	const [focusedInput, setFocusedInput] = useState(false);
	const [touched, setTouched] = useState(false);

	const isTextarea = typeof rows === 'number' && rows > 0;
	const showError = touched && required && (isTextarea ? !String(value || '').trim() : !value) && !error;
	const displayError = error || (showError ? 'Este campo es requerido' : null);

	const fieldClass = `
                        w-full ${Icon ? 'pl-12' : 'pl-4'} pr-4 py-2 
                        border-2 rounded-xl 
                        transition-all duration-300 outline-none
                        ${displayError
							? 'border-red-500 bg-white text-gray-900 placeholder-gray-400'
							: focusedInput
								? 'border-indigo-600 bg-indigo-50/50 shadow-lg shadow-indigo-200/50'
								: 'border-gray-200 bg-white hover:border-gray-300'
						}
                        disabled:bg-gray-50 disabled:cursor-not-allowed
                        focus:ring-4 ${displayError ? 'focus:ring-red-100' : 'focus:ring-indigo-100'}
						${isTextarea ? 'min-h-[120px] resize-y' : ''}
                    `;

	const handleFocus = () => setFocusedInput(true);
	const handleBlur = () => {
		setFocusedInput(false);
		setTouched(true);
	};

	return (
		<div className="w-full animate-slideUp">
			{label && (
				<label htmlFor={id} className="block text-sm font-semibold text-gray-700 mb-2">
					{label}
					{required && (
						<span className="text-red-500 ml-1" aria-hidden="true">
							*
						</span>
					)}
				</label>
			)}
			<div className="relative">
				{Icon && (
					<div
						className={`absolute left-0 flex pl-4 pointer-events-none transition-colors duration-300 ${
							isTextarea ? 'top-3 items-start' : 'inset-y-0 items-center'
						} ${displayError ? 'text-red-500' : focusedInput ? 'text-indigo-600' : 'text-gray-400'}`}
					>
						<Icon className="w-5 h-5 shrink-0" />
					</div>
				)}
				{isTextarea ? (
					<textarea
						id={id}
						name={name}
						rows={rows}
						value={value}
						onChange={onChange}
						onFocus={handleFocus}
						onBlur={handleBlur}
						placeholder={placeholder}
						disabled={disabled}
						className={fieldClass}
					/>
				) : (
					<input
						id={id}
						name={name}
						type={type}
						value={value}
						onChange={onChange}
						onFocus={handleFocus}
						onBlur={handleBlur}
						placeholder={placeholder}
						disabled={disabled}
						className={fieldClass}
					/>
				)}
			</div>
            {displayError && (
                <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    {displayError}
                </p>
            )}
        </div>
    );
};
